var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasino(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 6,
    y1: 11.902,
    x2: 6,
    y2: 0.2756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAC63A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE335"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M6.636,0.035C6.427,0.012,6.215,0,6,0C5.785,0,5.573,0.012,5.364,0.035C2.349,0.352,0,2.901,0,6 s2.349,5.648,5.364,5.965C5.573,11.988,5.785,12,6,12c0.215,0,0.427-0.012,0.636-0.035C9.651,11.648,12,9.099,12,6 S9.651,0.352,6.636,0.035z M6.636,9.935C6.429,9.968,6.217,9.986,6,9.986S5.571,9.968,5.364,9.935C3.465,9.631,2.014,7.984,2.014,6 c0-1.986,1.451-3.631,3.35-3.935C5.571,2.032,5.783,2.014,6,2.014s0.429,0.018,0.636,0.051C8.535,2.369,9.986,4.014,9.986,6 C9.986,7.984,8.535,9.631,6.636,9.935z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -0.8832 10.9611)",
    fill: "#262933",
    cx: 6,
    cy: 6,
    rx: 3.986,
    ry: 3.986
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262933",
    stroke: "#262933",
    strokeWidth: 0.0639,
    strokeMiterlimit: 10,
    d: "M6.636,0.035v11.931 C6.427,11.988,6.215,12,6,12c-0.215,0-0.427-0.012-0.636-0.035V0.035C5.573,0.012,5.785,0,6,0C6.215,0,6.427,0.012,6.636,0.035z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#262933",
    stroke: "#262933",
    strokeWidth: 0.0639,
    strokeMiterlimit: 10,
    d: "M2.238,1.343l8.436,8.436 c-0.131,0.164-0.273,0.322-0.425,0.474c-0.152,0.152-0.31,0.294-0.474,0.425L1.339,2.243C1.47,2.079,1.612,1.921,1.764,1.768 S2.074,1.474,2.238,1.343z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#262933",
    stroke: "#262933",
    strokeWidth: 0.0639,
    strokeMiterlimit: 10,
    d: "M1.362,9.776l8.436-8.436 c0.164,0.131,0.322,0.273,0.474,0.425s0.294,0.31,0.425,0.474l-8.436,8.436c-0.164-0.131-0.322-0.273-0.474-0.425 C1.635,10.098,1.493,9.94,1.362,9.776z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 6,
    y1: 11.902,
    x2: 6,
    y2: 0.2756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAC63A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE335"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M9.329,6c0,1.838-1.49,3.329-3.329,3.329S2.671,7.838,2.671,6c0-1.838,1.49-3.329,3.329-3.329 S9.329,4.161,9.329,6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#262933",
    d: "M8.441,6c0,1.348-1.093,2.441-2.441,2.441C4.652,8.441,3.559,7.348,3.559,6 c0-1.348,1.093-2.441,2.441-2.441C7.348,3.559,8.441,4.651,8.441,6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.2246,
    y1: 5.9893,
    x2: 9.7837,
    y2: 5.9893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAC63A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE335"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M5.614,9.763c-0.004,0-0.009,0-0.013-0.001C5.248,9.725,4.904,9.639,4.578,9.507 c-0.065-0.026-0.096-0.1-0.069-0.164c0.026-0.065,0.1-0.095,0.164-0.069c0.305,0.124,0.626,0.204,0.954,0.239 c0.069,0.007,0.12,0.069,0.112,0.139C5.732,9.715,5.677,9.763,5.614,9.763z M6.632,9.729c-0.06,0-0.114-0.043-0.124-0.105 C6.496,9.556,6.542,9.49,6.61,9.478C6.935,9.422,7.249,9.32,7.546,9.176c0.063-0.031,0.138-0.005,0.169,0.058 c0.031,0.063,0.005,0.138-0.058,0.169C7.339,9.558,7.001,9.667,6.653,9.727C6.646,9.728,6.639,9.729,6.632,9.729z M3.743,9.005 c-0.027,0-0.055-0.009-0.078-0.027C3.388,8.76,3.142,8.504,2.935,8.218C2.894,8.162,2.907,8.083,2.963,8.042 C3.019,8.001,3.098,8.014,3.139,8.07c0.193,0.267,0.423,0.505,0.682,0.709c0.055,0.043,0.064,0.122,0.021,0.177 C3.818,8.988,3.781,9.005,3.743,9.005z M8.446,8.845c-0.035,0-0.069-0.014-0.094-0.042C8.305,8.752,8.31,8.672,8.361,8.625 C8.607,8.405,8.82,8.151,8.995,7.872c0.037-0.059,0.115-0.077,0.174-0.04c0.059,0.037,0.077,0.115,0.04,0.174 C9.021,8.305,8.793,8.577,8.53,8.813C8.506,8.835,8.476,8.845,8.446,8.845z M2.56,7.37c-0.052,0-0.1-0.032-0.119-0.083 c-0.12-0.331-0.193-0.678-0.216-1.032C2.22,6.186,2.273,6.126,2.342,6.121c0.07-0.004,0.13,0.048,0.134,0.117 c0.022,0.329,0.09,0.653,0.202,0.963c0.024,0.065-0.01,0.138-0.076,0.162C2.588,7.368,2.574,7.37,2.56,7.37z M9.517,7.135 c-0.011,0-0.023-0.002-0.035-0.005C9.415,7.111,9.376,7.041,9.395,6.974C9.485,6.659,9.531,6.331,9.531,6 c0-0.159-0.011-0.319-0.032-0.477C9.49,5.454,9.539,5.39,9.608,5.381C9.679,5.371,9.74,5.42,9.75,5.489 C9.772,5.658,9.784,5.83,9.784,6c0,0.355-0.049,0.706-0.146,1.044C9.622,7.099,9.571,7.135,9.517,7.135z M2.424,5.357 c-0.009,0-0.018-0.001-0.027-0.003C2.329,5.34,2.285,5.272,2.3,5.204c0.074-0.345,0.196-0.678,0.363-0.99 c0.033-0.061,0.109-0.085,0.171-0.052c0.061,0.033,0.084,0.109,0.052,0.171C2.73,4.624,2.616,4.935,2.547,5.257 C2.534,5.316,2.482,5.357,2.424,5.357z M9.348,4.651c-0.048,0-0.095-0.028-0.116-0.075C9.1,4.275,8.926,3.994,8.714,3.74 C8.669,3.687,8.677,3.607,8.73,3.562c0.054-0.045,0.133-0.038,0.178,0.016C9.134,3.85,9.321,4.152,9.464,4.474 c0.028,0.064-0.001,0.138-0.065,0.166C9.383,4.648,9.365,4.651,9.348,4.651z M3.376,3.578c-0.032,0-0.063-0.012-0.088-0.036 c-0.05-0.049-0.051-0.128-0.003-0.178C3.532,3.11,3.812,2.893,4.117,2.717c0.06-0.034,0.137-0.014,0.172,0.047 c0.035,0.06,0.014,0.138-0.047,0.172C3.958,3.1,3.696,3.303,3.466,3.54C3.442,3.565,3.409,3.578,3.376,3.578z M8.056,3.101 c-0.024,0-0.049-0.007-0.071-0.022c-0.273-0.186-0.57-0.332-0.882-0.435C7.037,2.622,7.001,2.551,7.023,2.485 c0.022-0.066,0.093-0.103,0.159-0.08c0.335,0.11,0.653,0.267,0.945,0.466C8.185,2.909,8.2,2.988,8.161,3.045 C8.136,3.081,8.097,3.101,8.056,3.101z M5.126,2.573c-0.057,0-0.108-0.039-0.122-0.096C4.987,2.41,5.028,2.341,5.096,2.325 c0.341-0.084,0.697-0.12,1.049-0.106C6.214,2.221,6.268,2.28,6.266,2.35C6.263,2.42,6.199,2.481,6.135,2.471 C5.807,2.459,5.474,2.492,5.156,2.57C5.146,2.572,5.136,2.573,5.126,2.573z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#262933",
    d: "M2.014,6c0,0.402,0.061,0.79,0.171,1.156h7.63C9.926,6.79,9.986,6.402,9.986,6 c0-0.392-0.057-0.77-0.163-1.128H2.176C2.071,5.23,2.014,5.608,2.014,6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262933",
    d: "M2.014,6c0-0.392,0.057-0.77,0.163-1.128h-2.07C0.036,5.237,0,5.614,0,6c0,0.396,0.039,0.782,0.112,1.156 h2.073C2.074,6.79,2.014,6.402,2.014,6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262933",
    d: "M11.894,4.872h-2.07C9.929,5.23,9.986,5.608,9.986,6c0,0.402-0.061,0.79-0.171,1.156h2.073 C11.961,6.782,12,6.396,12,6C12,5.614,11.964,5.237,11.894,4.872z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.636,2.065C6.429,2.032,6.217,2.014,6,2.014c-0.217,0-0.429,0.018-0.636,0.051 C3.84,2.309,2.605,3.417,2.176,4.872h7.647C9.395,3.417,8.16,2.309,6.636,2.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M5.364,9.935C5.571,9.968,5.783,9.986,6,9.986c0.217,0,0.429-0.018,0.636-0.051 C8.15,9.693,9.379,8.596,9.815,7.156h-7.63C2.621,8.596,3.85,9.693,5.364,9.935z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FCE135",
    d: "M4.519,6.148v0.189c0,0.227-0.113,0.357-0.333,0.357c-0.219,0-0.333-0.13-0.333-0.357V5.598 c0-0.228,0.114-0.357,0.333-0.357c0.22,0,0.333,0.13,0.333,0.357v0.138H4.308V5.584c0-0.102-0.045-0.14-0.116-0.14 c-0.07,0-0.115,0.039-0.115,0.14v0.767c0,0.102,0.045,0.138,0.115,0.138c0.071,0,0.116-0.036,0.116-0.138V6.148H4.519z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE135",
    d: "M5.376,6.678H5.151L5.113,6.42H4.838L4.8,6.678H4.595l0.228-1.42h0.326L5.376,6.678z M4.867,6.227h0.216 L4.974,5.509L4.867,6.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE135",
    d: "M5.779,5.241c0.217,0,0.328,0.13,0.328,0.357v0.055H5.896V5.584c0-0.102-0.04-0.14-0.111-0.14 s-0.111,0.039-0.111,0.14c0,0.292,0.436,0.347,0.436,0.753c0,0.227-0.113,0.357-0.332,0.357c-0.22,0-0.333-0.13-0.333-0.357V6.239 h0.211v0.112c0,0.102,0.045,0.138,0.115,0.138c0.071,0,0.116-0.036,0.116-0.138c0-0.292-0.437-0.347-0.437-0.753 C5.45,5.371,5.561,5.241,5.779,5.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE135",
    d: "M6.236,5.257h0.224v1.42H6.236V5.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE135",
    d: "M6.821,5.649v1.029H6.619v-1.42H6.9l0.229,0.85v-0.85h0.198v1.42H7.098L6.821,5.649z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE135",
    d: "M7.468,5.598c0-0.228,0.12-0.357,0.339-0.357c0.22,0,0.34,0.13,0.34,0.357v0.739 c0,0.227-0.12,0.357-0.34,0.357c-0.219,0-0.339-0.13-0.339-0.357V5.598z M7.692,6.351c0,0.102,0.045,0.14,0.115,0.14 c0.071,0,0.116-0.039,0.116-0.14V5.584c0-0.102-0.045-0.14-0.116-0.14c-0.07,0-0.115,0.039-0.115,0.14V6.351z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasino);
export default __webpack_public_path__ + "static/media/Casino.01a4aa3a8a786d4b6106ba661b2d2615.svg";
export { ForwardRef as ReactComponent };